import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-us" }
const _hoisted_2 = { class: "container header-padding-compensation" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-3" }
const _hoisted_5 = { class: "footer-section mb-2 mb-md-0" }
const _hoisted_6 = { class: "footer-headline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block separator-line" }, null, -1)
const _hoisted_8 = { class: "links" }
const _hoisted_9 = { class: "links-column" }
const _hoisted_10 = { class: "ms-0 ms-lg-4 links-column" }
const _hoisted_11 = { class: "col-12 col-md-4" }
const _hoisted_12 = { class: "footer-section" }
const _hoisted_13 = { class: "footer-headline" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block separator-line" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"contacts\"><div class=\"contanct-column-1\"><p class=\"address\">Vibekegade 5, 1. tv <br>2100 København</p><p class=\"telephone\">+45 4272 2872 <br> (man-fre: 9-16)</p></div><div class=\"contanct-column-2\"><div><p>Email:</p><a href=\"mailto:info@suubz.com \" class=\"email\">info@suubz.com</a></div><p class=\"cvr\">CVR 42 22 51 34</p></div></div>", 1)
const _hoisted_16 = { class: "col-12 col-md-5" }
const _hoisted_17 = { class: "usp-section-wrapper" }
const _hoisted_18 = { class: "footer-headline" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block separator-line" }, null, -1)
const _hoisted_20 = { class: "usp-section footer-section" }
const _hoisted_21 = { class: "usp-section" }
const _hoisted_22 = { class: "usp-column" }
const _hoisted_23 = { class: "usp-container mb-2 mb-lg-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-snooze" }, null, -1)
const _hoisted_25 = { class: "usp-text" }
const _hoisted_26 = { class: "usp-container mb-md-2 mb-lg-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-mail-big" }, null, -1)
const _hoisted_28 = { class: "usp-text" }
const _hoisted_29 = { class: "ms-lg-2 usp-column" }
const _hoisted_30 = { class: "usp-container plus-minus mb-2 mb-lg-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-plus-minus" }, null, -1)
const _hoisted_32 = { class: "usp-text" }
const _hoisted_33 = { class: "usp-container" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-chain" }, null, -1)
const _hoisted_35 = { class: "usp-text" }
const _hoisted_36 = { class: "footer-copyright py-3" }
const _hoisted_37 = { class: "container header-padding-compensation" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-sm-6 col-lg-3" }
const _hoisted_40 = { class: "copyright d-none d-sm-block" }
const _hoisted_41 = { class: "year-label" }
const _hoisted_42 = { class: "right-reserved" }
const _hoisted_43 = { class: "col-sm-6 col-lg-3 pl-sm-0 pl-md-2" }
const _hoisted_44 = { class: "payment-methods-container" }
const _hoisted_45 = { class: "mb-2" }
const _hoisted_46 = { class: "payment-methods-wrapper" }
const _hoisted_47 = { class: "payment-method me-2" }
const _hoisted_48 = ["srcset"]
const _hoisted_49 = ["srcset"]
const _hoisted_50 = ["srcset"]
const _hoisted_51 = ["srcset"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "payment-method me-2" }
const _hoisted_54 = ["srcset"]
const _hoisted_55 = ["srcset"]
const _hoisted_56 = ["srcset"]
const _hoisted_57 = ["srcset"]
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "payment-method" }
const _hoisted_60 = ["srcset"]
const _hoisted_61 = ["srcset"]
const _hoisted_62 = ["srcset"]
const _hoisted_63 = ["srcset"]
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "col-sm-6 col-lg-3" }
const _hoisted_66 = { class: "social-media-container" }
const _hoisted_67 = { class: "d-none d-sm-block mb-2" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"social-media\"><a href=\"https://www.facebook.com/search/top?q=suubz\" class=\"facebook-social no-font-size\"><div class=\"social-circle\"><i class=\"ico ico-facebook\"></i></div> Facebook </a><a href=\"https://www.instagram.com/suubz.dk/\" class=\"instagram-social no-font-size\"><div class=\"social-circle\"><i class=\"ico ico-instagram\"></i></div> Instagram </a><a href=\"https://www.linkedin.com/company/suubz/about/?viewAsMember=true\" class=\"linkedin-social no-font-size\"><div class=\"social-circle\"><i class=\"ico ico-linkedin\"></i></div> Linkedin </a></div>", 1)
const _hoisted_69 = { class: "col-sm-6 col-lg-3 pl-sm-0 pl-md-2" }
const _hoisted_70 = { class: "newsletter-section" }
const _hoisted_71 = { class: "newsletter-label d-none d-sm-block mb-2" }
const _hoisted_72 = { class: "d-none d-sm-block" }
const _hoisted_73 = { class: "d-block d-sm-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('website.useful-links')), 1),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: "mb-2 mb-md-4",
                    to: {name: 'Catalog'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('website.ourproducts')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    class: "mb-2 mb-md-4",
                    to: {name: 'PartnerCatalogPage'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('website.our-partners')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    class: "mb-2 mb-md-4 mb-lg-0",
                    to: {name: 'GiftCertificate'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('website.gift-card')), 1)
                    ], undefined, true),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    class: "mb-2 mb-md-4",
                    to: {name: 'AboutUs'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('website.about-us')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: {name: 'FAQ'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('website.faq')), 1)
                    ], undefined, true),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('website.contact-us')), 1),
                _hoisted_14
              ]),
              _hoisted_15
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('website.why-us')), 1),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('website.selling-point-snooze-headline')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('website.selling-point-mail-footer')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('website.selling-point-plus-minus-headline')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('website.advantage-text-4')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("p", _hoisted_41, _toDisplayString(new Date().getFullYear()) + " - " + _toDisplayString(_ctx.$t('general.brand-name')) + ".", 1),
              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('website.all-rights-reserved')) + ".", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('website.payment-methods')) + ":", 1),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("picture", null, [
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 1200px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/visa.svg?w=38&h=12&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_48),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 992px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/visa.svg?w=38&h=120&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_49),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 768px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/visa.svg?w=38&h=12&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_50),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 576px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/visa.svg?w=38&h=12&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_51),
                    _createElementVNode("img", {
                      src: _ctx.$imgix('img/footer_payment_methods/visa.svg?w=38&h=12&auto=compress,format&fit=crop'),
                      alt: "Visa",
                      width: "38",
                      height: "12"
                    }, null, 8, _hoisted_52)
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("picture", null, [
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 1200px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/mastercard.svg?w=33&h=21&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_54),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 992px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/mastercard.svg?w=33&h=21&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_55),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 768px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/mastercard.svg?w=33&h=21&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_56),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 576px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/mastercard.svg?w=33&h=21&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_57),
                    _createElementVNode("img", {
                      src: _ctx.$imgix('img/footer_payment_methods/mastercard.svg?w=33&h=21&auto=compress,format&fit=crop'),
                      alt: "Mastercard",
                      width: "33",
                      height: "21"
                    }, null, 8, _hoisted_58)
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("picture", null, [
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 1200px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/diners-club.svg?w=25&h=20&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_60),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 992px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/diners-club.svg?w=25&h=20&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_61),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 768px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/diners-club.svg?w=25&h=20&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_62),
                    _createElementVNode("source", {
                      media: "only screen and (min-width: 576px)",
                      srcset: _ctx.$imgix('img/footer_payment_methods/diners-club.svg?w=25&h=20&auto=compress,format&fit=crop')
                    }, null, 8, _hoisted_63),
                    _createElementVNode("img", {
                      src: _ctx.$imgix('img/footer_payment_methods/diners-club.svg?w=25&h=20&auto=compress,format&fit=crop'),
                      alt: "Diners Club",
                      width: "25",
                      height: "20"
                    }, null, 8, _hoisted_64)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('website.our-social-media')) + ":", 1),
              _hoisted_68
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('website.sign-up-newsletter')) + "?", 1),
              _createVNode(_component_router_link, {
                class: "btn btn-primary btn-sm btn-block btn-subscribe-page",
                to: {name: 'SubscribePage'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('website.subscribe-newsletter-footer')), 1),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('website.subscribe-newsletter')), 1)
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}